import React from 'react';

const Divider = ({ className }) => {
  return <div className={`bg-border h-[1px] w-full ${className || ''}`} />;
};

export default Divider;
